import { CircleCloseIcon } from 'assets/icons';
import { CustomButton, CustomInput, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { InputType } from 'components/custom-input.tsx/CustomInput';
import React, { FC } from 'react';
import { VoidFn } from 'types/baseTypes';
import { cleanNumberInput, isValidDecimalInput } from 'containers/settings/utils';

interface EditReferralExpenseModalProps {
  onClose: VoidFn;
  onSave: (amount: number) => void;
  jobNumber: string;
  currentAmount?: number;
  isLoading?: boolean;
}

const EditReferralExpenseModal: FC<EditReferralExpenseModalProps> = ({
  onClose,
  onSave,
  jobNumber,
  currentAmount = 0,
  isLoading = false
}) => {
  const [amount, setAmount] = React.useState(currentAmount?.toFixed(2));

  const handleAmountChange = (value: string) => {
    const cleanedValue = cleanNumberInput(value);

    if (isValidDecimalInput(cleanedValue)) {
      setAmount(cleanedValue);
    }
  };

  const handleSave = () => {
    onSave(Number(amount));
  };

  return (
    <CustomModal open={true} width="md:w-[600px]">
      <div className="flex grow flex-col px-10">
        <div className="flex items-center justify-between py-6">
          <div className="text-headingGray">
            <div className="text-xl font-bold">Edit referral expense</div>
            <span className="mt-2 text-sbase font-semibold">{jobNumber}</span>
          </div>
          <CircleCloseIcon onClick={onClose} className="shrink-0 cursor-pointer" />
        </div>

        <div>
          <div className="mb-2 text-sbase font-semibold text-headingGray">Referral amount</div>
          <CustomInput
            id="referral-amount"
            value={amount}
            type={InputType.NUMBER}
            onChange={handleAmountChange}
            placeholder="0.00"
            prefix="$"
            prefixWrapperStyle="text-primaryText left-5 text-[17px]"
            className="w-full rounded-lg bg-secondaryBtn px-8 py-3 text-[17px] font-semibold text-primaryText"
          />
        </div>

        <div className="flex justify-end py-6">
          <CustomButton
            id="edit-referral-cancel-button"
            type={ButtonType.SECONDARY}
            onClick={onClose}
            className="mr-4 w-[100px]">
            Cancel
          </CustomButton>
          <CustomButton
            id="edit-referral-save-button"
            type={ButtonType.PRIMARY}
            onClick={handleSave}
            className="w-[100px]"
            isLoading={isLoading}
            disabled={!amount || isNaN(Number(amount))}>
            Save
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditReferralExpenseModal;
